import { axiosClient } from '../../../library/Service/axiosClient';
import pageConfig from './PageConfigList.json';

const BASE = () => `${process.env.REACT_APP_INTERNAL_ADMIN_SERVER}/company`;

class CompanyListingService {
    static pageLoader(params: any): Promise<any> {
        const searchCriteria = CompanyListingService.getDefaultSearchCriteria();
        return this.search(searchCriteria)
            .then((res: any) => ({
                formConfig: pageConfig,
                data: {
                    companyList: res.data ?? [],
                    searchCriteria,
                },
                routeInfo: params,
            }))
            .catch(() => ({
                formConfig: pageConfig,
                data: { companyList: [], searchCriteria },
                routeInfo: params,
            }));
    }

    static search(searchCriteria: any): any {
        return axiosClient().post(`${BASE()}/search`, searchCriteria);
    }

    static searchCount(searchCriteria: any): any {
        return axiosClient().post(`${BASE()}/count`, searchCriteria);
    }

    static delete(id: number): any {
        return axiosClient().delete(`${BASE()}/${id}`);
    }

    static getDefaultSearchCriteria(): any {
        return { name: '', country: '', industry_id: '', company_size: '', attributes: [] };
    }
}

export default CompanyListingService;
